import React, { useImperativeHandle } from 'react'
import { useFormik } from 'formik'

// graphql
import { GET_ALL_CREW_MEMBERS_FOR_REPLACE_SELECT_FIELD, GET_ALL_CREW_MEMBERS_FOR_REPLACE_WITH_SELECT_FIELD } from '../../../../graphql/crewMember/crewMember.queries'

// components
import FormSectionHeader from '../../../../components/forms/FormSectionHeader/FormSectionHeader.component'
import AsyncSelectField from '../../../../components/forms/AsyncSelectField/AsyncSelectField.component'


const ReplaceCrewMemberForm = React.forwardRef(({ jobDayId, errors }, ref) => {
    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: {
            assignment: '',
            newCrewMember: ''
        }
    })

    return (<form onSubmit={formik.handleSubmit}>

        <FormSectionHeader text='Replace' />
        <AsyncSelectField 
            id="assignment"
            value={formik.values.assignment}
            placeholder="Select an Assignment"
            onChange={value => {
                formik.setFieldValue('assignment', value.value)
            }}
            query={{
                query: GET_ALL_CREW_MEMBERS_FOR_REPLACE_SELECT_FIELD,
                variables: { id: jobDayId }, 
                rules: {
                    loopField: 'crewMemberAssignmentsForJobDay',
                    label: ['crewMember.firstName', 'crewMember.lastName'],
                    value: 'id'
                }
            }}
            isValid={errors['assignment']}
        />

        <FormSectionHeader text='With' />
        <AsyncSelectField 
            id="newCrewMember"
            value={formik.values.newCrewMember}
            placeholder="Select a Crew Member"
            onChange={value => {
                formik.setFieldValue('newCrewMember', value.value)
            }}
            query={{
                query: GET_ALL_CREW_MEMBERS_FOR_REPLACE_WITH_SELECT_FIELD,
                variables: { jobDay: jobDayId},
                rules: {
                    loopField: 'crewMembersAvailableForDate',
                    label: ['firstName', 'lastName'],
                    value: 'id'
                }
            }}
            isValid={errors['newCrewMember']}
        />
        
    </form>)
})

export default ReplaceCrewMemberForm